export default {
  getTeachersResult: (state) => state.teachersResult?.data,
  getTeachersResultPagination: (state) => state.teachersResult?.pagination,
};